"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _XXF5DFSGcjs = require('./XXF5DFSG.cjs');


var _5OZ7J4C2cjs = require('./5OZ7J4C2.cjs');


var _ZQYY7DF3cjs = require('./ZQYY7DF3.cjs');


var _QWIBF3KBcjs = require('./QWIBF3KB.cjs');


var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');





var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');



var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/menu/menu-item.tsx
var _dom = require('@ariakit/core/utils/dom');
var _events = require('@ariakit/core/utils/events');
var _focus = require('@ariakit/core/utils/focus');
var _misc = require('@ariakit/core/utils/misc');
var TagName = "div";
function menuHasFocus(baseElement, items, currentTarget) {
  var _a;
  if (!baseElement) return false;
  if (_focus.hasFocusWithin.call(void 0, baseElement)) return true;
  const expandedItem = items == null ? void 0 : items.find((item) => {
    var _a2;
    if (item.element === currentTarget) return false;
    return ((_a2 = item.element) == null ? void 0 : _a2.getAttribute("aria-expanded")) === "true";
  });
  const expandedMenuId = (_a = expandedItem == null ? void 0 : expandedItem.element) == null ? void 0 : _a.getAttribute("aria-controls");
  if (!expandedMenuId) return false;
  const doc = _dom.getDocument.call(void 0, baseElement);
  const expandedMenu = doc.getElementById(expandedMenuId);
  if (!expandedMenu) return false;
  if (_focus.hasFocusWithin.call(void 0, expandedMenu)) return true;
  return !!expandedMenu.querySelector("[role=menuitem][aria-expanded=true]");
}
var useMenuItem = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useMenuItem2({
    store,
    hideOnClick = true,
    preventScrollOnKeyDown = true,
    focusOnHover,
    blurOnHoverEnd,
    ...props
  }) {
    const menuContext = _XXF5DFSGcjs.useMenuScopedContext.call(void 0, true);
    const menubarContext = _5OZ7J4C2cjs.useMenubarScopedContext.call(void 0, );
    store = store || menuContext || menubarContext;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "MenuItem must be wrapped in a MenuList, Menu or Menubar component"
    );
    const onClickProp = props.onClick;
    const hideOnClickProp = _3BSDKDKDcjs.useBooleanEvent.call(void 0, hideOnClick);
    const hideMenu = "hideAll" in store ? store.hideAll : void 0;
    const isWithinMenu = !!hideMenu;
    const onClick = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
      onClickProp == null ? void 0 : onClickProp(event);
      if (event.defaultPrevented) return;
      if (_events.isDownloading.call(void 0, event)) return;
      if (_events.isOpeningInNewTab.call(void 0, event)) return;
      if (!hideMenu) return;
      const popupType = event.currentTarget.getAttribute("aria-haspopup");
      if (popupType === "menu") return;
      if (!hideOnClickProp(event)) return;
      hideMenu();
    });
    const contentElement = _FH6HQ5JNcjs.useStoreState.call(void 0, 
      store,
      (state) => "contentElement" in state ? state.contentElement : null
    );
    const role = _dom.getPopupItemRole.call(void 0, contentElement, "menuitem");
    props = {
      role,
      ...props,
      onClick
    };
    props = _QWIBF3KBcjs.useCompositeItem.call(void 0, {
      store,
      preventScrollOnKeyDown,
      ...props
    });
    props = _ZQYY7DF3cjs.useCompositeHover.call(void 0, {
      store,
      ...props,
      focusOnHover(event) {
        const getFocusOnHover = () => {
          if (typeof focusOnHover === "function") return focusOnHover(event);
          if (focusOnHover != null) return focusOnHover;
          return true;
        };
        if (!store) return false;
        if (!getFocusOnHover()) return false;
        const { baseElement, items } = store.getState();
        if (isWithinMenu) {
          if (event.currentTarget.hasAttribute("aria-expanded")) {
            event.currentTarget.focus();
          }
          return true;
        }
        if (menuHasFocus(baseElement, items, event.currentTarget)) {
          event.currentTarget.focus();
          return true;
        }
        return false;
      },
      blurOnHoverEnd(event) {
        if (typeof blurOnHoverEnd === "function") return blurOnHoverEnd(event);
        if (blurOnHoverEnd != null) return blurOnHoverEnd;
        return isWithinMenu;
      }
    });
    return props;
  }
);
var MenuItem = _PTOCUU2Dcjs.memo.call(void 0, 
  _PTOCUU2Dcjs.forwardRef.call(void 0, function MenuItem2(props) {
    const htmlProps = useMenuItem(props);
    return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
  })
);




exports.useMenuItem = useMenuItem; exports.MenuItem = MenuItem;
